import { Injectable } from '@angular/core';
import {isTitleProvider, isTitleStringProvider, TitleProvider, TitleStringProvider} from "@app/layout/layout.types";
import {MessageTranslateService} from "@shared/services";

@Injectable({
  providedIn: 'root'
})
export class TitleProviderService {

  constructor(private translateService: MessageTranslateService) {
  }

  public isTitleProvider(component: any): boolean {
    return isTitleProvider(component) || isTitleStringProvider(component);
  }

  public getTitle(titleProvider: TitleProvider | TitleStringProvider | null): string | null {
    if (isTitleProvider(titleProvider)) {
      const title = titleProvider.getTitle();
      return title ? this.translateService.instant(title) : null;
    } else if (isTitleStringProvider(titleProvider)) {
      return titleProvider.getTitleStr() ?? null;
    } else {
      return null;
    }
  }
}
